import AllInclusiveIcon from '@mui/icons-material/AllInclusive';

export const All = () => <AllInclusiveIcon fontSize="small" />;
